import { DataSyncManager } from './DataSyncManager'
import { SqlQueryExecutor } from './SqlQueryExecutor'

export const sqlQueryExecutor = new SqlQueryExecutor()

export const dataSyncManager = new DataSyncManager()
